import { printFormApi } from "../../../services/forms.services";

export const prophylaxisKeys = [
  { label: "UFH", value: "UFH" },
  { label: "LMWH", value: "LMWH" },
  { label: "FONDAPARINUX", value: "FONDAPARINUX" },
  { label: "Warfarin", value: "Warfarin" },
  { label: "Apixaban", value: "Apixaban" },
  { label: "Reveroxaban", value: "Reveroxaban" },
  { label: "Dabigatran", value: "Dabigatran" },
  { label: "Others", value: "Others" },
];
export const hospitalKeys = [
  {
    label: "as advised by the physicians",
    value: "as advised by the physicians",
  },
  { label: "as per family preference", value: "as per family preference" },
];
export const initialGrade = [
  { label: "Grade 1", value: "Grade 1" },
  { label: "Grade 2", value: "Grade 2" },
  { label: "Grade 3", value: "Grade 3" },
  { label: "Grade 4", value: "Grade 4" },
];
export const finalGrade = [
  { label: "Grade 1", value: "Grade 1" },
  { label: "Grade 2", value: "Grade 2" },
  { label: "Grade 3", value: "Grade 3" },
  { label: "Grade 4", value: "Grade 4" },
  { label: "Normal", value: "Normal" },
];
export const pressureSoreKeys = [
  { label: "Left Scapular", value: "left_scapular" },
  { label: "Right Scapular", value: "right_scapular" },
  { label: "Left Arm", value: "left_arm" },
  { label: "Right Arm", value: "right_arm" },
  { label: "Left Fore Arm", value: "left_fore_arm" },
  { label: "Right Fore Arm", value: "right_fore_arm" },
  { label: "Sacral", value: "sacral" },
  { label: "Left Gluteal", value: "left_gluteal" },
  { label: "Right Gluteal", value: "right_gluteal" },
  { label: "Left Hamstring", value: "left_hamstring" },
  { label: "Right Hamstring", value: "right_hamstring" },
  { label: "Left Heel", value: "left_heel" },
  { label: "Right Heel", value: "right_heel" },
];
export const getPastMedicalHistoryFormSummary = (
  options = [],
  formData = {}
) => {
  const enteredOptions = options.reduce((acc, option) => {
    let labelCreated = "";
    if (formData?.[option.value]) {
      labelCreated = option.label;

      if (option?.value === "past_medical_others") {
        const othersList = formData?.past_medical_others_list;
        const othersName = formData?.past_medical_others_name; // old format

        // ✅ New format — list
        if (Array.isArray(othersList) && othersList?.length) {
          const othersLabels = othersList
            .filter((item) => item?.name)
            .map((item) => {
              let label = item.name;
              if (item?.yrs) label += ` since ${item.yrs} yrs`;
              if (item?.control) label += ` : ${item.control}`;
              return label;
            })
            .join(", ");
          labelCreated = `${option.label}: ${othersLabels}`;

          // ✅ Old format — plain string
        } else if (typeof othersName === "string" && othersName) {
          labelCreated = `${option.label} name: ${othersName}`;
          if (formData?.past_medical_others_yrs)
            labelCreated += ` since ${formData.past_medical_others_yrs} yrs`;
          if (formData?.past_medical_others_control)
            labelCreated += ` : ${formData.past_medical_others_control}`;
        }
      } else {
        if (formData?.[option.value + "_yrs"]) {
          labelCreated += ` since ${formData?.[option.value + "_yrs"]} yrs`;
        }
        if (formData?.[option.value + "_control"]) {
          labelCreated += ` : ${formData?.[option.value + "_control"]}`;
        }
      }
    }

    labelCreated && acc.push(labelCreated);
    return acc;
  }, []);

  return enteredOptions?.length === 0
    ? null
    : enteredOptions.map((label) => label);
};

export const getLabelTagsWithFormDescription = (
  options = [],
  formData = {}
) => {
  const enteredOptions = options.reduce((acc, option) => {
    if (formData?.[option.value]) {
      if (formData?.[option.value + "_description"]) {
        acc.push(
          `${option.label}: ${formData?.[option.value + "_description"]}`
        );
      } else {
        acc.push(option.label);
      }
    }
    return acc;
  }, []);
  return enteredOptions?.length === 0
    ? null
    : enteredOptions?.map((label, index) => label);
};
export const printFormSummary = async (formType, id) => {
  const submitParams = `form_type=${formType}&form_id=${id}`;

  try {
    const resp = await printFormApi(submitParams);
    if (resp && resp?.data?.data) {
      const printDocument = document.createElement("div");
      printDocument.innerHTML = resp?.data?.data;

      // Create a temporary iframe
      const iframe = document.createElement("iframe");
      document.body.appendChild(iframe);

      // Ensure iframe is loaded with content before printing
      const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
      iframeDoc.open();
      iframeDoc.write(printDocument.outerHTML);
      iframeDoc.close();

      // Wait briefly to allow images to load
      setTimeout(() => {
        iframe.contentWindow.print();
        document.body.removeChild(iframe);
      }, 300); // Adjust delay if needed (e.g., 500ms)
    }
  } catch (error) {
    console.error(error);
  }
  // finally {
  //   navigate && navigate("/receptionist/billing");
  // }
};
